import React from 'react';
import { ProjectStyle } from '@atlassian/jira-common-constants/src/project-types.tsx';
import {
	ContextualAnalyticsData as ContextualAnalyticsDataBase,
	type AnalyticsContextData,
} from '@atlassian/jira-product-analytics-bridge';
import { useProject as useProjectDI } from '../../controllers/project/index.tsx';
import { generateViewId } from '../../utils/generate-view-id.tsx';

export type ContextualAnalyticsDataProps = AnalyticsContextData & {
	menuId: string;
	stack?: string[];
};

export type IssuesContextualAnalyticsDataProps = AnalyticsContextData & {
	navigatorScope: string;
	useProject?: typeof useProjectDI;
};

export const ContextualAnalyticsData = ({
	attributes,
	menuId,
	stack = [],
	...rest
}: ContextualAnalyticsDataProps): React.JSX.Element => (
	<ContextualAnalyticsDataBase
		{...rest}
		attributes={{
			// @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
			navVersion: '3',
			viewId: generateViewId(menuId, ...stack),
			navigationLayer: 'container',
			...attributes,
		}}
	/>
);

export const IssuesContextualAnalyticsData = ({
	attributes,
	navigatorScope,
	// eslint-disable-next-line react-hooks/react-compiler
	useProject = useProjectDI,
	...rest
}: IssuesContextualAnalyticsDataProps): React.JSX.Element => {
	// eslint-disable-next-line react-hooks/react-compiler
	const { data: project } = useProject();
	const projectConfig =
		(project?.isSimplified ? ProjectStyle.NEXT_GEN : ProjectStyle.CLASSIC) || undefined;
	const projectType = project?.type || undefined;
	return (
		<ContextualAnalyticsDataBase
			{...rest}
			attributes={{
				...attributes,
				projectConfig,
				projectType,
				navigatorScope,
			}}
		/>
	);
};
